import styles from "./styles.module.css";
import { useEffect, useState } from "react";
import useUtilities from "../../../utils/useutilities";
import PropInput from "./propinput";

export default function Editor({ open, utility, onChange, onDelete }) {
  const [name, setName] = useState(utility.displayName);
  const [schema, setSchema] = useState(null);
  const utilities = useUtilities();

  useEffect(() => {
    setName(utility.displayName);
    const schema = utilities.find((x) => x.name === utility.name);
    setSchema(schema);
  }, [utility]);

  const handleNameChange = () => {
    const _u = { ...utility };
    _u.displayName = name;
    onChange(_u);
  };

  return (
    <div className={open ? `${styles.editor} ${styles.open}` : styles.editor}>
      <div className={styles.propTitle}>NAME</div>
      <input
        className={styles.nameInput}
        onChange={(e) => setName(e.target.value)}
        value={name}
        onBlur={handleNameChange}
      />
      {schema &&
        schema.props.map((prop, index) => {
          return (
            <PropInput
              key={prop.name}
              prop={prop}
              utility={utility}
              index={index}
              onChange={onChange}
              sources={[]}
            />
          );
        })}
      {!schema && (
        <div style={{ marginTop: 20 }} className={styles.propTitle}>
          This utility no longer exists in your app. You likely removed the
          plugin that contained it.
        </div>
      )}
      <div style={{ marginTop: 20 }} className={styles.propTitle}>
        Danger Zone
      </div>
      <button onClick={() => onDelete(utility)} className={styles.delete}>
        Delete
      </button>
    </div>
  );
}
